import { createFileRoute } from '@tanstack/react-router';
import { ComissaoPage } from '@/features/comissao/page/ComissaoPage';

export const Route = createFileRoute('/a/comissao/')({
    component: ComissaoPage,
});
